{
  "cycle.entite.programme_derogations_ecart": "Dérogations des programmes pour garder un écart technologique",
  "journalAudit.action.program.technologies_inherited": "Programme : toutes les technologies héritées de l’organisation",
  "journalAudit.action.program.technology_deviation_kept": "Programme : écart technologique gardé avec dérogation",
  "journalAudit.action.program.technology_change_decided": "Programme : changement technologique décidé",
  "journalAudit.action.program.deviation_waiver_requested": "Programme : dérogation pour garder l’écart demandée"
}
